import { render, staticRenderFns } from "./MarksJournalActionsView.vue?vue&type=template&id=f92b0bb8&"
import script from "./MarksJournalActionsView.vue?vue&type=script&lang=js&"
export * from "./MarksJournalActionsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports